import { QueryKeysEnum } from '@/enums';
import {
  GetByKitSerialParams,
  SampleParams,
} from '@/pages/privatePages/kit/types/sample';
import {
  CreateSampleDto,
  DefaultEntity,
  SampleEntity,
  UploadExtractionSequence,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class SampleService extends BaseService<'sample', SampleEntity, DefaultEntity> {
  constructor() {
    super(QueryKeysEnum.SAMPLE);
  }

  getByKitSerial = (params: GetByKitSerialParams): Promise<SampleEntity[]> => {
    return APIService.get(this.path, {
      params,
    });
  };

  streamSamplesBySerials = (params: SampleParams): Promise<string> => {
    const { serials, ...rest } = params;
    return APIService.get(this.path + `/stream-sample-by-kit-serials`, {
      params: { ...rest, kitSerials: serials },
      responseType: 'stream',
    });
  };

  updateSample = (payload: {
    sampleId: string;
    data: SampleEntity;
  }): Promise<SampleEntity> => {
    const { data, sampleId } = payload;

    return APIService.patch(this.path + '/' + sampleId, data);
  };

  updateManySamples = (
    samplesData: SampleEntity[],
  ): Promise<SampleEntity[]> => {
    return APIService.patch(this.path + '/many', samplesData);
  };

  createSamples = (payload: CreateSampleDto): Promise<SampleEntity[]> => {
    return APIService.post(this.path + '/many', payload);
  };

  // region Extraction sequences
  uploadManyExtractionSequences = (
    payload: UploadExtractionSequence,
  ): Promise<{
    error: Record<string, any>[];
    success: Record<string, any>[];
  }> => {
    const data = new FormData();
    Object.entries(payload).forEach(([key, payloadValue]) => {
      if (Array.isArray(payloadValue)) {
        payloadValue.forEach(itemValue => data.append(key, itemValue));
      } else {
        data.append(key, payloadValue);
      }
    });

    return APIService.post(this.path + '/extraction-multiple-detail', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };
}
export const sampleService = new SampleService();
